<template>
  <div class="section__lk-content-item" @click="toVideo">
    <div class="section__lk-content-item-left">
      <div class="icon video"></div>
      <div class="section__lk-content-item-separator"></div>
      <div class="section__lk-content-item-data">
        <div class="section__lk-content-item-data-title">
        </div>
        <div class="section__lk-content-item-data-content">
          <div>
            <div class="section__lk-content-item-data-title">
              {{ result.type_ru }}
            </div>
            <div>{{ result.title }} <img src="/pic/profile/arrow-up-right.svg" /></div>
          </div>
        </div>
      </div>
    </div>
    <div class="section__lk-content-item-right section__lk-enroll">
      <div class="section__lk-enroll-icon">
        <img src="/pic/profile/icon-time.svg" />
        <div>
          Длительность:
          {{ (result.data.duration / 60).toFixed(0) }} мин.
        </div>
      </div>
      <div class="section__lk-enroll-status">
        <div class="status" :class="'status_' + result.status"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OnlineRowVideo",
  props: ['result', 'course', 'module'],
  methods: {
    toVideo() {
      this.$router.push(`/course/${this.course.id}/module/${this.module.index}/lecture/${this.result.data.index}`).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>